import { call, put } from "redux-saga/effects";

import { api, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateJustificationsActions } from "store/ducks/settings/justifications";

export function* paginateJustificationsRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      api.get,
      `/justifications?${queryString}`
    );

    const { justifications, pagination } = responseBody;
    yield put(
      PaginateJustificationsActions.success(justifications, pagination)
    );
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateJustificationsActions.failure(errorMessage));
  }
}
